import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function SecretModal({ isOpen, toggle, clientName, secret }) {
  const [copied, setCopied] = useState(false);

  function copySecret() {
    navigator.clipboard.writeText(secret).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        {clientName ? `Client Secret — ${clientName}` : 'Client Secret'}
      </ModalHeader>
      <ModalBody>
        <div className="alert-info-custom mb-3">
          <strong>Save this secret now.</strong> It will not be shown again.
        </div>
        <div className="secret-display mb-3">{secret}</div>
        <Button
          color="secondary"
          size="sm"
          onClick={copySecret}
          style={{ borderRadius: 6 }}
        >
          {copied ? 'Copied!' : 'Copy to clipboard'}
        </Button>
      </ModalBody>
      <ModalFooter>
        <Button className="btn-primary" onClick={toggle}>
          I have saved the secret
        </Button>
      </ModalFooter>
    </Modal>
  );
}
